export const LUXURY_LOFT_TYPE = 'LUXURY-LOFT';
export const PREMIUM_LOFT_TYPE = 'PREMIUM-LOFT';
